import { root } from './options';

export const options = {
  ...root,
};
